import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5f0cdd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "job-container",
  style: {"margin-top":"20px"}
}
const _hoisted_2 = { class: "filtering-buttons" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "dropdown-content" }
const _hoisted_6 = { class: "search-bar" }
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "styled-table" }
const _hoisted_9 = {
  key: 0,
  scope: "col"
}
const _hoisted_10 = {
  key: 1,
  scope: "col"
}
const _hoisted_11 = {
  key: 2,
  scope: "col"
}
const _hoisted_12 = {
  key: 3,
  scope: "col"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 4,
  scope: "col"
}
const _hoisted_15 = {
  key: 5,
  scope: "col"
}
const _hoisted_16 = {
  key: 6,
  scope: "col"
}
const _hoisted_17 = {
  key: 7,
  scope: "col"
}
const _hoisted_18 = {
  key: 8,
  scope: "col"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["onMouseover"]
const _hoisted_23 = {
  key: 0,
  class: "popover"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { key: 2 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = { key: 5 }
const _hoisted_33 = { key: 6 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "$", -1))
const _hoisted_35 = { key: 7 }
const _hoisted_36 = { key: 8 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "no-jobs-message"
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "No Jobs in this category.")
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "pagination-controls" }
const _hoisted_42 = { class: "pagination" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["disabled"]

import DateTimeBadge from '@/components/DateTimeBadge.vue';
import UserBadge from '@/components/UserBadge.vue'
import { ref, onMounted, watch, computed, PropType } from 'vue';
import { Job, Task } from '@/types/Ops'
import { deleteFromUrl } from '@/api/api';
import { useEmployeeStore } from '@/stores/UserEmployee';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobList',
  props: {
  jobs: {
    type: Array as PropType<Job[]>,
    default: undefined
  },
  visibleColumns: {
    type: Array as PropType<string[]>,
    default: () => ['id', 'name', 'description', 'task_count', 'status', 'total_active_duration', 'total_cost', 'actions']

  }
},
  setup(__props) {

const props = __props

const jobs = ref<Job[]>([]);
const employeeStore = useEmployeeStore();
let jobLoaded = false;
const showDescription = ref(null);
const sortKey = ref('id');
const sortOrder = ref(1);
const searchQuery = ref('');
const initialSerialNumbers = ref({});
const filterAllJobs = ref(true);
const filterCompletedJobs = ref(false)
const filterActiveJobs = ref(false);
const filerNotStartedJobs = ref(false);
const sortDropdownVisible = ref(false);
const pageSize = ref(15);
const currentPage = ref(1);

const toggleSortDropdown = () => {
  sortDropdownVisible.value = !sortDropdownVisible.value;
};

function updateSort(key) {
  if (sortKey.value === key) {
    sortOrder.value = -sortOrder.value;
  } else {
    sortKey.value = key;
    sortOrder.value = 1;
  }
  sortDropdownVisible.value = false;
}

const truncateDescription = (description) => {
  const maxLength = 50;
  if (description.length > maxLength) {
    return description.substring(0, maxLength) + '...';
  }
  return description;
}

function truncateMilliseconds(durationStr) {
  return durationStr.split('.')[0];
}

const paginatedJobs = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return filteredJobs.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(filteredJobs.value.length / pageSize.value);
});

const serialNumbers = computed(() => {
  const map = {};
  sortedJobs.value.forEach((task, index) => {
    map[task.id] = index + 1;
  });
  return map;
});

const sortArrow = computed(() => {
  return sortOrder.value === 1 ? '↓' : '↑';
});

function durationStringToMilliseconds(durationStr) {
  let totalMilliseconds = 0;

  const parts = durationStr.split(' ');
  const timeParts = parts.pop().split(':');
  const dayPart = parts.pop() || '0';

  totalMilliseconds += parseInt(dayPart, 10) * 24 * 60 * 60 * 1000;
  totalMilliseconds += parseInt(timeParts[0], 10) * 60 * 60 * 1000;
  totalMilliseconds += parseInt(timeParts[1], 10) * 60 * 1000;
  totalMilliseconds += parseFloat(timeParts[2]) * 1000;

  return totalMilliseconds;
}

const sortedJobs = computed(() => {
  return jobs.value.slice().sort((a, b) => {
    if (sortKey.value === 'Name') {
      return sortOrder.value * a.name.localeCompare(b.name);
    } else if (sortKey.value === 'Started') {
      if (!a.started && !b.started) {
        return sortOrder.value * (a.id - b.id);
      }
      if (!a.started) return 1;
      if (!b.started) return -1;
      return sortOrder.value * (new Date(a.started).getTime() - new Date(b.started).getTime());
    } else if (sortKey.value === 'Cost') {
      const costA = a.total_labor_cost ?? 0;
      const costB = b.total_labor_cost ?? 0;
      return sortOrder.value * (costA - costB);
    } else if (sortKey.value === 'Duration') {
      const durationA = a.total_active_duration ? durationStringToMilliseconds(a.total_active_duration) : 0;
      const durationB = b.total_active_duration ? durationStringToMilliseconds(b.total_active_duration) : 0;
      return sortOrder.value * (durationA - durationB);
    }
    return sortOrder.value * (a.id - b.id);
  });
});

function completedTasks(tasks: Task[]): number {
  let concludedTasksCount = 0;
  tasks.forEach(task => {
    if (task.concluded !== null && task.concluded !== undefined) {
      concludedTasksCount++;
    }
  });
  return concludedTasksCount;
}

const getPriorityClass = (priority) => {
  switch (priority) {
    case 1: return 'low-priority';
    case 2: return 'medium-priority';
    case 3: return 'high-priority';
    default: return '';
  }
};

const filteredJobs = computed(() => {
  let filtered = sortedJobs.value;
  if (searchQuery.value) {
    const searchLower = searchQuery.value.toLowerCase();
    filtered = filtered.filter(job => {
      const nameMatch = job.name.toLowerCase().includes(searchLower);
      const descriptionMatch = job.description.toLowerCase().includes(searchLower);
      const workCenterMatch = job.work_center?.name?.toLowerCase().includes(searchLower) || false;
      return nameMatch || descriptionMatch || workCenterMatch;
    });
  }
  if (filterActiveJobs.value) {
    filtered = filtered.filter(job => job.started && (job.completed === null && !job.completed));
  } else if (filterCompletedJobs.value) {
    filtered = filtered.filter(job => job.completed !== null && job.completed !== undefined);
  } else if (filerNotStartedJobs.value) {
    filtered = filtered.filter(job => !job.started && !job.completed);
  }

  return filtered;
})

const goToPage = (pageNumber) => {
  currentPage.value = pageNumber;
};

const goToPrevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const goToNextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const setFilterAll = () => {
  filterAllJobs.value = true;
  filterActiveJobs.value = false;
  filterCompletedJobs.value = false;
  filerNotStartedJobs.value = false;
};

const setFilterActive = () => {
  filterAllJobs.value = false;
  filterActiveJobs.value = true;
  filterCompletedJobs.value = false;
  filerNotStartedJobs.value = false;
};

const setFilterCompleted = () => {
  filterAllJobs.value = false;
  filterActiveJobs.value = false;
  filterCompletedJobs.value = true;
  filerNotStartedJobs.value = false;
};

const setFilterNotStarted = () => {
  filterAllJobs.value = false;
  filterActiveJobs.value = false;
  filterCompletedJobs.value = false;
  filerNotStartedJobs.value = true;
}

const deleteJob = async (jobId, index) => {
  if (confirm('Are you sure you to delete this job?')) {

    try {
      await deleteFromUrl(`/ops/api/jobs/${jobId}/`);
      jobs.value.splice(index, 1);
    } catch (error) {
      console.error('Error deleting job:', error);
    }
  }
}

onMounted(() => {
  if (props.jobs) {
    jobs.value = props.jobs.filter(job => !job.name.includes("template"));
    // console.log(jobs.value)
    jobs.value = [...props.jobs].sort((a, b) => a.id - b.id);
    jobs.value.forEach((job, index) => {
      initialSerialNumbers.value[job.id] = index + 1;
    })
    jobLoaded = true;
  } else {
    console.log("Jobs are not loading either they are not provided or undefined !(JobList.vue)");
  }
})

watch(() => props.jobs, (newTasks) => {
  if (newTasks) {
    jobs.value = newTasks.filter(job => !job.name.includes("template"));
    jobs.value = jobs.value.sort((a, b) => a.id - b.id);
    initialSerialNumbers.value = {};
    jobs.value.forEach((job, index) => {
      initialSerialNumbers.value[job.id] = index + 1;
    });
  }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button all-jobs", { 'active-filter': filterAllJobs.value }]),
        onClick: setFilterAll
      }, " Show All Jobs ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button completed-jobs", { 'active-filter': filterCompletedJobs.value }]),
        onClick: setFilterCompleted
      }, " Completed Jobs ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button active-jobs", { 'active-filter': filterActiveJobs.value }]),
        onClick: setFilterActive
      }, " Active Jobs ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button not-started-jobs", { 'active-filter': filerNotStartedJobs.value }]),
        onClick: setFilterNotStarted
      }, " Not Started ", 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "apple-button sort-button",
          onClick: toggleSortDropdown
        }, [
          _createTextVNode(" Sort By "),
          (sortKey.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(sortKey.value) + " " + _toDisplayString(sortArrow.value), 1))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "apple-button id",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateSort('Id')))
          }, "Id"),
          _createElementVNode("button", {
            class: "apple-button name",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateSort('Name')))
          }, "Name"),
          _createElementVNode("button", {
            class: "apple-button started",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (updateSort('Started')))
          }, "Started"),
          _createElementVNode("button", {
            class: "apple-button cost",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (updateSort('Cost')))
          }, "Cost"),
          _createElementVNode("button", {
            class: "apple-button duration",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateSort('Duration')))
          }, "Duration")
        ], 512), [
          [_vShow, sortDropdownVisible.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        class: "search-input",
        type: "text",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchQuery).value = $event)),
        placeholder: "Search Name of Job..."
      }, null, 512), [
        [_vModelText, searchQuery.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (__props.visibleColumns.includes('id'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Sr. No."))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('name'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Job Name"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('description'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Description"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('task_count'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_12, [
                  _createTextVNode("Number of Tasks"),
                  _hoisted_13,
                  _createTextVNode("(Completed/Total)")
                ]))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('status'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_14, "Status"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('total_active_duration'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_15, "Active Duration"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('total_cost'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Labor Cost"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('created_by'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Created By"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('actions'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Action"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (paginatedJobs.value.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(paginatedJobs.value, (job, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: job.id,
                  class: _normalizeClass(getPriorityClass(job.priority))
                }, [
                  (__props.visibleColumns.includes('id'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(initialSerialNumbers.value[job.id]), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('name'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(job.name), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('description'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                        _createElementVNode("div", {
                          class: "job-description",
                          onMouseover: ($event: any) => (showDescription.value = job.id),
                          onMouseout: _cache[6] || (_cache[6] = ($event: any) => (showDescription.value = null))
                        }, [
                          _createTextVNode(_toDisplayString(truncateDescription(job.description)) + " ", 1),
                          (showDescription.value === job.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createTextVNode("Job Description:"),
                                _hoisted_24,
                                _createTextVNode(_toDisplayString(job.description), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_22)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('task_count'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, "Tasks: " + _toDisplayString(completedTasks(job.tasks)) + "/" + _toDisplayString(job.tasks.length), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('status'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                        (!job.started)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Not Started"))
                          : (job.started && !job.completed)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createTextVNode("Ongoing"),
                                _hoisted_29,
                                _createTextVNode("Started on "),
                                _createVNode(DateTimeBadge, {
                                  time: job?.started
                                }, null, 8, ["time"])
                              ]))
                            : (job.completed)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createTextVNode("Completed on"),
                                  _hoisted_31,
                                  _createVNode(DateTimeBadge, {
                                    time: job?.completed
                                  }, null, 8, ["time"])
                                ]))
                              : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('total_active_duration'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(truncateMilliseconds(job.total_active_duration)), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('total_cost'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                        _hoisted_34,
                        _createTextVNode(" " + _toDisplayString(job.total_labor_cost), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('created_by'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                        _createVNode(UserBadge, {
                          "user-id": job?.created_by
                        }, null, 8, ["user-id"])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('actions'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          class: "apple-button view-button",
                          to: { name: 'job-view', params: { id: job.id } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("View")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (_unref(employeeStore).currentUser.user?.is_superuser || _unref(employeeStore).currentUser.user?.is_staff)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "apple-button delete-button",
                              onClick: ($event: any) => (deleteJob(job.id, index))
                            }, "Delete", 8, _hoisted_37))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_38, _hoisted_40))
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_41, [
      _createElementVNode("ul", _hoisted_42, [
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: goToPrevPage,
            disabled: currentPage.value === 1
          }, "Previous", 8, _hoisted_43)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["page-item", { active: currentPage.value === page }]),
            key: page
          }, [
            _createElementVNode("button", {
              class: "page-link",
              onClick: ($event: any) => (goToPage(page))
            }, _toDisplayString(page), 9, _hoisted_44)
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: goToNextPage,
            disabled: currentPage.value === totalPages.value
          }, "Next", 8, _hoisted_45)
        ], 2)
      ])
    ])
  ]))
}
}

})